import { Box, Button } from "@mui/material";
import TableFC, { TableFCBodyProps } from "../../components/table/Table";
import TableHeader from "../../components/table/TableHeader";
import { MainPadding } from "../../styles/Main.styles";
import {
  useDeleteGrouping,
  useExportFromFile,
  useGetGroupingDetails,
  useImportFromFile,
} from "../produk-detail/network/resolver";
import { useGetProduct } from "../produk/network/resolver";
import { useState } from "react";
import { ModalFC } from "../../components/modal/Modal";
import GroupingHistory from "../produk-detail/components/GroupingHistory";
import { LoadingButton } from "../../components/button/Button";
import {
  AutocompleteOption,
  SearchAutocomplete,
} from "../../components/input/AutocompleteSearch";
import { useGenerateAutoCompleteSearch } from "../../components/input/hook/useGenerateOptions";
import { useParamUrl } from "../invoice/hooks/param/Param";

export default function Grouping() {
  const { getPage, setUrlPage } = useParamUrl();
  const [keywordProduct, setKeywordProduct] = useState("");
  const [page, setPage] = useState(getPage());
  const [perPage, setPerPage] = useState(10);
  const [selectedProduct, setSelectedProduct] =
    useState<AutocompleteOption | null>(null);
  const { data: dataRawProducts, isLoading: loadingProduct } = useGetProduct({
    keyword: keywordProduct,
    is_under_threshold: 0,
    customer_type_id: -1,
    page,
  });
  const dataProduct = dataRawProducts?.data?.data?.data;
  const { data: dataProdcutOptions } = useGenerateAutoCompleteSearch({
    keyForText: "name",
    keyForValue: "id",
    dataSource: dataProduct,
  });
  const [showModal, setShowModal] = useState<
    "InsertGrouping" | "InsertHistory" | undefined
  >(undefined);
  const [idGrouping, setIdGrouping] = useState<number | undefined>(undefined);
  const { mutate: mutateDelete, isLoading: loadingDelete } =
    useDeleteGrouping();
  const { data: dataRawGroupingDetail, isLoading: loadingFetchDetails } =
    useGetGroupingDetails({
      product_id: selectedProduct?.value,
      page,
      perPage,
    });
  const dataGroupingDetail = dataRawGroupingDetail?.data.data.data;
  const { mutate: mutateImportFile, isLoading: loadingImport } =
    useImportFromFile();
  const { mutate: mutateExport, isLoading: loadingExport } =
    useExportFromFile();
  const header: string[] = [
    "No",
    "Nama Group",
    "Nama Barang",
    "Jumlah Awal",
    "Jumlah Sekarang",
    "",
    "",
  ];
  const body: TableFCBodyProps[] = [
    {
      key: "group_name",
    },
    {
      key: "product.name",
    },
    {
      key: "initial_stock",
    },
    {
      key: "current_stock",
    },
    {
      key: "",
      newComponent: (e) => {
        return (
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setIdGrouping(e.id);
              setShowModal("InsertHistory");
            }}
          >
            Detail
          </Button>
        );
      },
    },
    {
      key: "",
      newComponent: (e) => {
        return (
          <Button
            color="error"
            variant="outlined"
            size="small"
            onClick={() => {
              if (confirm("Apakah Anda Yakin ?")) {
                mutateDelete({ id: e.id });
              }
            }}
            disabled={loadingDelete}
          >
            Hapus
          </Button>
        );
      },
    },
  ];

  const RenderButton = () => {
    return (
      <Box marginTop={2} display={"flex"} gap={1}>
        <LoadingButton
          isLoading={loadingImport}
          isUpload
          accept=".csv"
          text="Upload"
          variant="contained"
          color="success"
          onUpload={(files) => {
            if (files) {
              mutateImportFile({ file: files[0] });
            }
          }}
        />
        <LoadingButton
          isLoading={loadingExport}
          variant="contained"
          color="secondary"
          text="Download"
          onClick={() => mutateExport()}
        />
      </Box>
    );
  };

  return (
    <MainPadding>
      <TableHeader
        title="Grouping Produk"
        renderFilter={
          <Box>
            <SearchAutocomplete
              label="Nama Barang"
              options={dataProdcutOptions}
              value={selectedProduct}
              onChange={(e) => setSelectedProduct(e)}
              inputValue={keywordProduct}
              onInputChange={(e) => setKeywordProduct(e)}
            />
            <RenderButton />
          </Box>
        }
      />
      <TableFC
        showIndex
        loading={loadingFetchDetails}
        data={dataGroupingDetail}
        head={header}
        totalRows={dataRawGroupingDetail?.data?.data?.total}
        perColumns={perPage}
        onPerPageChange={(e) => setPerPage(e)}
        onPageChange={(e) => {
          setUrlPage(e);
          setPage(e);
        }}
        body={body}
        onCellClick={(e) => {
          setShowModal("InsertGrouping");
        }}
      />
      <ModalFC
        open={showModal === "InsertHistory"}
        onClose={() => setShowModal(undefined)}
      >
        <GroupingHistory grouping_product_id={idGrouping} />
      </ModalFC>
    </MainPadding>
  );
}
